import type { ArcadeGameKind } from "../utils/arcade/games";

// Per song arcade settings, keyed by the song's /games/:slug. Every song already
// gets its own look from its cover art and a featured game picked from its
// title, so an entry here is only for overriding that.
//
//   featuredGame  the game the song opens on
//   games         the games offered for this song, in order (defaults to all four)
//   hue           0 to 360, replaces the colour taken from the cover
//   bpm           the tempo of the practice beat used while the song is not playing
//   pattern       the backdrop: "grid", "rings", "stars" or "waves"
//
// Example:
//   "gold-soul": { featuredGame: "vinyl-orbit", hue: 44, bpm: 92 },
export interface ArcadeReleaseOverride {
  featuredGame?: ArcadeGameKind;
  games?: ArcadeGameKind[];
  hue?: number;
  bpm?: number;
  pattern?: "grid" | "rings" | "stars" | "waves";
}

export const ARCADE_RELEASE_OVERRIDES: Record<string, ArcadeReleaseOverride> = {};
